import { z } from 'zod';
import { ChatActionType } from '../enums';
// Shared form data structure for log interaction actions
export const FormDataItemModel = z.object({
    fieldLabel: z.string(),
    value: z.any(),
});
export const FormDataArrayModel = z.array(FormDataItemModel).optional();
export const ReaskWithHcpModel = z.object({
    type: z.literal(ChatActionType.ReaskWithHcp),
    payload: z.object({
        hcpId: z.number(),
        queryId: z.number(),
    }),
});
export const LocationItemModel = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('browser'),
        latitude: z.number(),
        longitude: z.number(),
    }),
    z.object({
        type: z.literal('search'),
        longitude: z.number(),
        latitude: z.number(),
        name: z.string(),
        id: z.string(),
    }),
    z.object({
        type: z.literal('hcp'),
        longitude: z.number(),
        latitude: z.number(),
        name: z.string(),
        id: z.number(),
    }),
]);
export const SelectLocationModel = z.object({
    type: z.literal(ChatActionType.SelectLocation),
    payload: z.object({
        location: LocationItemModel,
        queryId: z.number(),
    }),
});
export const BuildRouteModel = z.object({
    type: z.literal(ChatActionType.BuildRoute),
    payload: z.object({
        origin: z.object({
            latitude: z.number(),
            longitude: z.number(),
            address: z.string(),
            kolId: z.number().nullable(),
        }),
        kols: z.array(z.object({
            kolId: z.number(),
            location: z.optional(z.object({
                latitude: z.number(),
                longitude: z.number(),
                address: z.string(),
            })),
        })),
    }),
});
export const SubmitFormWorkflowModel = z.object({
    type: z.literal(ChatActionType.SubmitFormWorkflow),
    payload: z.object({
        queryId: z.number(),
        workflowType: z.string(), // e.g., 'log-interaction', 'schedule-interaction', 'patient-survey', etc.
        formParentId: z.number().optional(),
        formVersion: z.string().optional(),
        formState: z.enum([
            'initial',
            'manual-entry',
            'speech-entry',
            'draft',
            'submitted',
            'cancelled',
            'probing',
        ]).optional(),
        formData: FormDataArrayModel,
        aiState: z.any().optional(),
    }),
});
export const ChartQuantAnalysesChatActionModel = z.object({
    type: z.literal(ChatActionType.ChartQuantAnalyses),
    quantId: z.number(),
    quantItemId: z.number(),
    query: z.string(),
    projectId: z.number(),
});
export const QueryFilesChatActionModel = z.object({
    type: z.literal(ChatActionType.QueryFiles),
    query: z.string(),
});
export const FindQuotesChatActionModel = z.object({
    type: z.literal(ChatActionType.FindQuotes),
    subject: z.string(),
});
// Zod schema for Chat.Attachment.AskSurveyQuestionSuggestedAction
export const QuerySurveyQuestionChatActionModel = z.object({
    type: z.literal(ChatActionType.QuerySurveyQuestion),
    project: z.object({
        id: z.number(),
        name: z.string(),
    }),
    question: z.object({
        id: z.number(),
        base: z.object({ id: z.number() }),
        ordinal: z.number(),
        value: z.string(),
    }),
    survey: z.object({
        id: z.number(),
        name: z.string(),
    }),
});
export const SummarizeFolderChatActionModel = z.object({
    type: z.literal(ChatActionType.SummarizeFolder),
    payload: z.object({
        folderId: z.number(),
    }),
});
export const LoadDraftModel = z.object({
    type: z.literal(ChatActionType.LoadDraft),
    payload: z.object({
        queryId: z.number(),
        draftId: z.string(),
    }),
});
